var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-3d-product-prices" },
    [
      _c(
        "div",
        {
          staticClass: "rb-3d-product-prices__original",
          class: {
            "rb-3d-product-prices__original--strikethrough": _vm.hasPromotion,
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.prices.original) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.hasPromotion
        ? [
            _c("div", { staticClass: "rb-3d-product-prices__discounted" }, [
              _vm._v("\n      " + _vm._s(_vm.prices.discounted) + "\n    "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rb-3d-product-prices__badge" },
              [
                _c("rb-pill", { attrs: { size: "xsmall" } }, [
                  _vm._v("\n        " + _vm._s(_vm.prices.badge) + "\n      "),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }